<template>
    <div class="flex gap-3 mb-3 sticky left-0">
        <div class="grow flex flex-col border-b-2 border-white">
            <div class="flex items-center gap-3 flex-grow pr-3">
                <i @click="$emit('update:expanded', !expanded)"
                   class="icon-chevron_giu h-4 cursor-pointer transition ease-linear duration-100 transform-gpu"
                   :class="{'-rotate-90': !expanded}"></i>
                <input :disabled="readonly" :value="titolo"
                       @change="$emit('update:titolo', $event.target.value)" type="text"
                       class="bg-transparent text-xl flex-grow" placeholder="Nuova sezione">
            </div>
            <div class="flex justify-between">
                <SezioneHead
                    v-if="!hideTotal"
                    :totaleCosti="totaleCosti"
                    :budgetProgetto="budgetProgetto"
                    :primoMarigne="primoMarigne"
                    :fee="fee"
                    :primoMarignePerc="primoMarignePerc"
                    class="w-1/2"
                ></SezioneHead>
                <div v-show="!readonly" class="flex">
                    <span
                        class="tooltip-activator relative flex items-center cursor-pointer hover:text-next-orange mr-2"
                        @click="$emit('clickDuplicaSezione')">
                        <i class="icon-duplica h-4 px-2"></i>
                        <Tooltip class="-translate-y-1.5">Duplica</Tooltip>
                    </span>
                    <span
                        class="tooltip-activator relative flex items-center cursor-pointer hover:text-next-orange mr-2"
                        @click="$emit('clickAggiungiSezione')">
                        <i class="icon-croce_cerchiata h-4 px-2"></i>
                        <Tooltip class="-translate-y-1.5">Aggiungi sezione</Tooltip>
                    </span>
                    <ConfirmDelete :readonly="!$attrs['deletable'] || readonly"
                                   @cancella="$emit('cancella')" position="left"
                                   class="px-2">
                    </ConfirmDelete>
                    <div class="text-sm flex items-center border-b-2 border-white gap-3 px-2">
                        <i class="icon-chevron_destra cursor-pointer -rotate-90"
                           :class="[first ? 'invisible': 'visible']"
                           @click="$emit('orderUp')"></i>
                        <div>{{ order }}</div>
                        <i class="icon-chevron_destra cursor-pointer rotate-90" :class="[last ? 'invisible': 'visible']"
                           @click="$emit('orderDown')"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div :class="{'max-h-0 overflow-hidden': !expanded}" class="transition transform-gpu">
        <slot>
        </slot>
    </div>
    <div class="flex justify-center sticky left-0 mb-5" v-show="!readonly">
        <span class="flex items-center cursor-pointer hover:text-next-orange mr-2" @click="$emit('clickAddRow')">
            <i class="icon-croce_cerchiata h-4 px-2"></i>
            Agg. Riga
        </span>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import ConfirmDelete from "@/components/ConfirmDelete.vue";
import SezioneHead from "@/views/SezioneHead.vue";
import Tooltip from "@/components/Tooltip.vue";

@Options({
    name: 'SezioneSottoProgetti',
    components: {Tooltip, SezioneHead, ConfirmDelete},
    props: {
        titolo: String,
        collapse: Boolean,
        order: Number,
        first: Boolean,
        last: Boolean,
        expanded: Boolean,
        totaleCosti: String,
        budgetProgetto: String,
        fee: String,
        primoMarignePerc: String,
        primoMarigne: String,
        hideTotal: {
            type: Boolean,
            default: false
        },
    }
})
export default class SezioneSottoProgetti extends Vue {

    get readonly() {
        return this.$attrs['readonly'] !== undefined
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
